module.exports = __webpack_public_path__ + "static/media/white_logo.aa617740.gif";